/**
 * useForceUpdate
 * Forces re-render, similar to `forceUpdate` in class components.
 *
 * Created by Samuel on 2022/8/11
 */

import { useState, useCallback } from 'react';

export function useForceUpdate() {
	let [, dispatch] = useState(Object.create(null));
	return useCallback(() => {
		dispatch(Object.create(null));
	}, []);
}
